import React from "react";
import EmailCampaignCard from "./EmailCampaignCard";

function EmailCampaignList({ campaigns = [] }: { campaigns?: any[] }) {
  return (
    <div className="row mt-3">
      {campaigns.map((campaign) => (
        <div className="col-md-12" key={campaign.id}>
          <EmailCampaignCard campaign={campaign} />
        </div>
      ))}
    </div>
  );
}

export default EmailCampaignList;
